import ContentAccess from "./ContentAccess.jsx"

export default ContentAccess;